






































































import pxButton from '@/dex-shared/components/px-button.vue';
import getAssetPath from '@/helpers/assets';

export default {
  components: {
    pxButton,
  },
  data() {
    return {
      logoSrc: getAssetPath('logo_descomplica.svg'),
      profilePicture: getAssetPath('user_white.svg'),
    };
  },
};
